import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-edit-item-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule // ✅ THIS IS REQUIRED
  ],
  templateUrl: './edit-item-dialog-component.html',
  styleUrls: ['./edit-item-dialog-component.scss']
})
export class EditItemDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<EditItemDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { productName: string; quantity: number; price: number }
  ) { }

  save(): void {
    this.dialogRef.close(this.data);
  }

  deleteItem(): void {
    this.dialogRef.close({ delete: true });
  }

  increaseQuantity(): void {
    this.data.quantity++;
  }

  decreaseQuantity(): void {
    if (this.data.quantity > 1) {
      this.data.quantity--;
    }
  }
}
